var map = {
	"./Murmeli0.gif": "9329",
	"./Murmeli1.gif": "96f8",
	"./Murmeli2.gif": "c3aa",
	"./Murmeli3.gif": "011f",
	"./Murmeli4.gif": "adca",
	"./Murmeli5.gif": "8896"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "240f";